import { Helmet } from 'react-helmet';
import metadata from '../../../config/metadata';

interface PageProps {
  page: string,
}

const Meta = ({ page }:PageProps) => {
  //@ts-ignore
  const pageMeta = metadata[page] || metadata.default;

  return (
    <Helmet>
      <title>{pageMeta.title}</title>
      <meta name="description" content={pageMeta.description} />

        {/*Google / Search Engine Tags */}
      <meta itemProp="name" content={pageMeta.title} />
      <meta itemProp="description" content={pageMeta.description} />
      <meta itemProp="image" content={pageMeta.image} />

      {/*Facebook Meta Tags*/}
      <meta property="og:url" content={window.location.toString()} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={pageMeta.title} />
      <meta property="og:description" content={pageMeta.description} />
      <meta property="og:image" content={pageMeta.image} />

       {/*Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageMeta.title} />
      <meta name="twitter:description" content={pageMeta.description} />
      <meta name="twitter:image" content={pageMeta.image} />
    </Helmet>
  )
}

export default Meta;